/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import RangeSeasons from './modules/range-seasons'
_('range-seasons').nodes().map((el) => new RangeSeasons(el))
*/

import noUiSlider from 'nouislider'
import { _ } from '../utils'

export default class RangeSeasons {
    constructor(el) {
        this.el = el
        this.range = _('range', 'element').nodeFrom(this.el)
        this.checkboxes = _('checkbox-seasons').nodesFrom(this.el)
        this.rangeSlider = noUiSlider.create(this.range, {
            start: [0, 4],
            connect: true,
            margin: 1,
            step: 1,
            range: {
                min: 0,
                max: 4
            }
        })
        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', this.updateRange)
        })
        this.range.noUiSlider.on('change', this.updateInputs)
        this.updateRange()
    }

    updateRange = (e) => {
        const checkedSeasons = this.checkboxes.filter((season) => season.checked)
        if (!checkedSeasons.length && e) {
            e.currentTarget.checked = true
            e.currentTarget.dispatchEvent(new Event('change'))
            return false
        }
        const seasonValues = checkedSeasons.map((season) => season.dataset.id)
        const minSeason = Math.min(...seasonValues)
        const maxSeason = Math.max(...seasonValues)
        this.rangeSlider.set([minSeason, maxSeason + 1])
        for (let i = minSeason; i <= maxSeason - 1; i++) {
            this.el.querySelector(`[id="season-${i}"]`).checked = true
        }
    }

    updateInputs = () => {
        const rangeValues = this.rangeSlider.get()
        const bottomRange = parseFloat(rangeValues[0]).toFixed(0)
        const topRange = parseFloat(rangeValues[1]).toFixed(0) - 1
        const fullRange = []
        for (let i = bottomRange; i <= topRange; i++) {
            fullRange.push(i)
        }

        this.checkboxes.forEach((checkbox) => {
            checkbox.checked = false
        })

        fullRange.forEach((seasonNumber) => {
            this.el.querySelector(`[id="season-${seasonNumber}"]`).checked = true
        })
        _('make-endpoint').node().dispatchEvent(new Event('click'))
    }
}
